import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { get as _get } from "lodash";

class VisualsView extends Component {
  renderSeqCard(roleData, variant, sectionRole) {
    // variant: "pink" | "aqua"
    const { intl } = this.props;
    const role = _get(roleData, "role", "");
    const context = _get(roleData, "context", "");
    const messaging = _get(roleData, "messaging", "");
    const recommendedAsset = _get(roleData, "recommended_asset", "");

    const badgeClass = `sa-seq-card__role-badge sa-seq-card__role-badge--${variant}`;
    const bulletClass = `sa-seq-card__bullet sa-seq-card__bullet--${variant}`;

    return (
      <div className="sa-seq-card">
        {role && (
          <span className={badgeClass}>
            {intl.formatMessage(
              { id: "strategic_analysis.view_report.visuals.seq_card.for_role", defaultMessage: "For {role}" },
              { role }
            )}
          </span>
        )}

        {(sectionRole === "senior") && (
          <h4 className="sa-driver-card__title">
            <FormattedMessage id="strategic_analysis.view_report.visuals.seq_card.business_role" defaultMessage="The Business Risk Sequence" />
          </h4>
        )}
        {(sectionRole === "practitioner") && (
          <h4 className="sa-driver-card__title">
            <FormattedMessage id="strategic_analysis.view_report.visuals.seq_card.practitioner_role" defaultMessage="The Operational Challenge Sequence" />
          </h4>
        )}
        {
          context && (
            <ul className="sa-seq-card__list">
              {context && (
                <li className="sa-seq-card__list-item">
                  <span className={bulletClass}>•</span>
                  <div>
                    <strong>
                      {intl.formatMessage({
                        id: "strategic_analysis.view_report.visuals.seq_card.context_label",
                        defaultMessage: "The Context: ",
                      })}
                    </strong>
                    {context}
                  </div>
                </li>
              )}
              {messaging && (
                <li className="sa-seq-card__list-item">
                  <span className={bulletClass}>•</span>
                  <div>
                    <strong>
                      {intl.formatMessage({
                        id: "strategic_analysis.view_report.visuals.seq_card.messaging_label",
                        defaultMessage: "The Messaging: ",
                      })}
                    </strong>
                    {messaging}
                  </div>
                </li>
              )}
            </ul>
          )
        }
        {
          recommendedAsset && (
            <div className="sa-seq-card__asset-box">
              <p className="sa-seq-card__asset-label">
                {intl.formatMessage({
                  id: "strategic_analysis.view_report.visuals.seq_card.recommended_asset_label",
                  defaultMessage: "Recommended Asset",
                })}
              </p>
              <p className="sa-seq-card__asset-text">{recommendedAsset}</p>
            </div>
          )
        }
      </div >
    );
  }

  render() {
    const marketDrivers = _get(this.props, "reportData.sections.visuals.market_drivers", []);
    const salesSequence = _get(this.props, "reportData.sections.visuals.sales_sequence", {});
    const seniorRole = _get(salesSequence, "senior_role", null);
    const practitionerRole = _get(salesSequence, "practitioner_role", null);
    const clientName = _get(this.props, "reportData.client_name", "");
    //const campaignName = _get(this.props, "reportData.campaign_name", "");

    return (
      <div className="sa-tab-content">
        {/* Section heading */}
        <div className="mb-5">
          <span className="sa-section-badge">
            <FormattedMessage
              id="strategic_analysis.view_report.visuals.badge"
              defaultMessage="Executive Presentation"
            />
          </span>
          <h2 className="sa-section-title">
            <FormattedMessage
              id="strategic_analysis.view_report.visuals.title"
              defaultMessage="Strategic Outreach Alignment"
            />
          </h2>
          <p className="sa-section-desc">
            <FormattedMessage
              id="strategic_analysis.view_report.visuals.desc"
              defaultMessage="Insights derived by cross-referencing campaign engagement data with current market research."
            />
          </p>
          {(clientName || "") && (
            <p className="sa-section-desc mt-1">
              <FormattedMessage
                id="strategic_analysis.view_report.visuals.alignment_desc"
                defaultMessage="Designed to align {name}'s Sales and Marketing messaging."
                values={{ name: clientName || "" }}
              />
            </p>
          )}
        </div>

        {/* Market Drivers section */}
        <div className="mb-5">
          <h3 className="d-flex align-items-center gap-3 fw-bold mb-4">
            <span className="sa-step-badge">01</span>
            <FormattedMessage
              id="strategic_analysis.view_report.visuals.market_drivers"
              defaultMessage="Market Drivers Evident in Lead Data"
            />
          </h3>
          <div className="row g-4">
            {marketDrivers.map((driver, index) => (
              <div key={`driver-${index}`} className="col-md-4">
                <div className={`sa-driver-card ${_get(driver, "card-class", "")}`}>
                  <h4 className="sa-driver-card__title">{_get(driver, "title", "")}</h4>
                  <p className="sa-driver-card__desc">{_get(driver, "description", "")}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Targeted Sales Sequencing section */}
        {(seniorRole || practitionerRole) && (
          <div className="mb-5">
            <h3 className="d-flex align-items-center gap-3 fw-bold mb-4">
              <span className="sa-step-badge">02</span>
              <FormattedMessage
                id="strategic_analysis.view_report.visuals.sales_sequencing"
                defaultMessage="Targeted Sales Sequencing"
              />
            </h3>
            <div className="row g-4">
              {seniorRole && (
                <div className="col-6">
                  {this.renderSeqCard(seniorRole, "pink", "senior")}
                </div>
              )}
              {practitionerRole && (
                <div className="col-6">
                  {this.renderSeqCard(practitionerRole, "aqua", "practitioner")}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(VisualsView);
